<template>
  <div class="filter">
    <p-vue-input-text
      v-model="search"
      class="search"
      :placeholder="__('Enter a phrase to search for an apartment')"
      @input="filterByName"
    />
    <a href="#" @click.prevent="filterModal = true">
      <i-icon name="filter" />
    </a>
  </div>
  <div class="panels" v-if="apartments?.length > 0">
    <p-vue-panel
      v-for="(item, index) of apartmentsFilterd"
      :key="index"
      :toggleable="true"
      :collapsed="item.collapsed"
      :class="{
        'p-panel-collapsed': item.collapsed,
      }"
      :name="item.UID"
    >
      <template #header>
        <a
          href="#"
          class="toggler"
          @click.prevent="item.collapsed = !item.collapsed"
        >
          <h4 class="name">{{ item.name }}</h4>
          <i-icon name="arrow" />
        </a>
      </template>
      <p-apartments-and-tenants
        :apartmentData="item"
      ></p-apartments-and-tenants>
    </p-vue-panel>
  </div>
  <h1 class="no-data" v-else-if="apartments">
    {{ __("There are no apartments for this building") }}
  </h1>
  <p-vue-sidebar
    position="left"
    class="sidebar--menu"
    id="apartments-and-tenants-filter"
    :style="{
      padding: 0,
      maxWidth: '275px',
    }"
    v-model:visible="filterModal"
  >
    <p-filter
      @filter="filter"
      :close="() => (filterModal = false)"
      :apartments="apartments"
    />
  </p-vue-sidebar>
</template>

<script>
import { mapState } from "vuex";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { errorReceived } from "@/services/apointUtil";
import PFilter from "@/components/partials/apartments-and-tenants/filter";
import PApartmentsAndTenants from "@/components/partials/p-apartments-and-tenants";
import { __ } from "@/plugins/i18n";
import { ScrollTo } from "@/services/Scroll";
export default {
  components: {
    PFilter,
    PApartmentsAndTenants,
  },
  plugins: { __ },
  data() {
    return {
      apartments: null,
      search: "",
      filterModal: false,
      apartmentsFilterd: [],
    };
  },
  mounted() {
    this.getUnits();
  },
  methods: {
    getUnits() {
      if (this.bID != 0) {
        let procParams = [
          apiParam("UserNum", this.userNum, apiPType.Int),
          apiParam("BID", this.bID, apiPType.Int),
        ];
        callProc("WorkerApp_ListUnits", procParams)
          .then((result) => {
            result = JSON.parse(result);
            /*
            בקריאה זו חוזרות 7 טבלאות:
            Table - סוגי דירות
            Table1 - סוגי אופן תשלום
            Table2 - סוגי ניהול
            Table3 - פרטי הבניין
            Table4 - רשימת יחידות
            Table5 - שוכרים
            Table6 - בעלים
            */

            // console.log(result);
            let myApartments = [];
            result.Table.forEach((item) => {
              item.ownerContact = result.Table2.filter(
                (f) => f.UID == item.UID
              );
              if (item.ownerContact.length > 0)
                item.ownerContact[0].type = "Owner";
              item.renterContact = result.Table1.filter(
                (f) => f.UID == item.UID
              );
              if (item.renterContact.length > 0)
                item.renterContact[0].type = "Tenants";
              item.collapsed = true;
              item.name = `${item.UTypeName} ${__("num")} ${item.Number} ${__(
                "Entrance"
              )} ${item.Entrance}`;
              item.IsLegal = item.IsLegal == 1;
              if (this.apartmentSelected?.UID == item.UID) {
                item.collapsed = false;
              }
              myApartments.push(item);
            });
            this.apartments = myApartments;

            this.apartmentsFilterd = this.apartments;
            if (this.apartmentSelected)
              setTimeout(() => {
                ScrollTo(
                  document.querySelector(`div[name='${this.apartmentSelected.UID}']`),
                  undefined,
                  false
                );
              }, 1);
            // console.log(this.apartments);
          })
          .catch(() => {
            errorReceived("WorkerApp_ListUnits");
          });
      }
    },
    filterByName(event) {
      this.apartmentsFilterd = this.apartments.filter(
        (f) =>
          f.name.includes(event.target.value) ||
          f.ownerContact.filter(
            (o) =>
              o.FirstName?.includes(event.target.value) ||
              o.LastName?.includes(event.target.value) ||
              o.TelMobile?.includes(event.target.value) ||
              o.Email?.includes(event.target.value)
          ).length > 0 ||
          f.renterContact.filter(
            (r) =>
              r.FirstName?.includes(event.target.value) ||
              r.LastName?.includes(event.target.value) ||
              r.TelMobile?.includes(event.target.value) ||
              r.Email?.includes(event.target.value)
          ).length > 0
      );
    },
    filter(event) {
      this.apartmentsFilterd = this.apartments;
      this.search = "";
      if (event.apartment.selected)
        this.apartmentsFilterd = this.apartmentsFilterd.filter(
          (f) => f.Number == event.apartment.selected
        );
      if (event.entrance.selected)
        this.apartmentsFilterd = this.apartmentsFilterd.filter(
          (f) => f.Entrance == event.entrance.selected
        );
      if (event.thereIsAdebt.selected)
        this.apartmentsFilterd = this.apartmentsFilterd.filter(
          (f) =>
            (f.HovUnit != 0 && event.thereIsAdebt.selected.value == true) ||
            (f.HovUnit == 0 && event.thereIsAdebt.selected.value == false)
        );
    },
    showHov(apartment) {
      var contactId = 0;
      if (apartment.renterContact.length > 0)
        contactId = apartment.renterContact[0].ContactID;
      else if (apartment.ownerContact.length > 0)
        contactId = apartment.ownerContact[0].ContactID;
      if (contactId > 0)
        this.$router.push("/financial-report/" + contactId + "/0");
    },
  },
  computed: {
    ...mapState({
      bID: (state) => state.api.bID,
      userNum: (state) => state.api.workerID,
      apartmentSelected: (state) => state.apartmentSelected,
    }),
  },
  // watch: {
  //   bID() {
  //     this.getData();
  //   },
  // },
};
</script>

<style scoped>
.button--show {
  padding: 0 12px;
  margin-right: 5px;

  color: var(--color-success-active) !important;
}

.filter {
  display: flex;
  justify-content: space-between;

  padding: 10px 15px 5px;

  background-color: var(--color-primary);
}

.filter a {
  color: white;

  margin-right: 3px;
}

.filter a:deep(.svg) {
  width: 24px;
  height: 24px;
}

.search {
  flex: 1;

  padding: 0 0 8px 0;

  border-radius: 0;
  border: 1px solid white;
  border-width: 0 0 1px 0;
  background-color: transparent;

  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.search::placeholder {
  color: white;
  font-size: 16px;
  line-height: 1.28;
  font-style: italic;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.toggler {
  flex: 0 0 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 10px 15px;

  color: inherit;
  text-decoration: none;
}

.content {
  display: grid;
  align-items: flex-start;
  justify-content: space-between;
  grid-template-columns: auto auto;

  border-top: 1px solid white;

  padding: 20px 0 15px;
}

.content > div {
  gap: 20px 5px;
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr;

  font-size: 14px;
  color: #080808;
  line-height: 1.46;
  font-weight: normal;
  letter-spacing: 0.45px;
}

.content > div span {
  display: flex;
  align-items: center;
}

:deep(label) {
  color: var(--color-primary-hover);
}

.content ul {
  margin: 0;
  padding: 0;

  list-style: none;
}

.content ul li {
  gap: 15px;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
}

.p-panel {
  border-bottom: 1px solid var(--color-border-alt);
}

.p-panel:deep(.p-panel-content) {
  padding: 0 15px;

  border: none;
}

.p-panel:deep(.p-panel-header) {
  padding: 0px;
}

.p-panel:deep(.p-panel-header .svg) {
  width: 15px;
  height: 15px;

  color: var(--color-success);

  transform: rotate(180deg);

  transition: transform 0.3s ease;
}

.name {
  margin: 0;

  color: black;
  font-size: 16px;
  line-height: 1.28;
  font-weight: normal;
  letter-spacing: 0.51px;
}

.panels:deep(.p-panel.p-panel-collapsed .name) {
  color: var(--color-label);
}

.panels:deep(.p-panel.p-panel-collapsed .svg) {
  transform: rotate(0deg);
}

:deep(.p-datatable) {
  padding-top: 7px;
  padding-bottom: 7px;

  border-top-color: var(--color-border);
}

:deep(.p-datatable tr) {
  background: transparent;
}

:deep(.p-datatable tr td) {
  padding: 5px 0;

  border: none;
}

.no-data {
  text-align: center;
  color: var(--color-success);
}
</style>
